import React from 'react';
import { CardGrid, CardGridCardProps, CardGridProps } from '../../Card/CardGrid/CardGrid';
import { NoResultsPlaceholder } from '../../NoResultsPlaceholder/NoResultsPlaceholder';
import { ContentfulFilter } from '../../hooks/useContentfulEntries/useContentfulEntries';
import { useCards } from '../../hooks/useCards';
import { getNoCardsPlaceholderProps } from '../transformers/CardGridTransformer';

export type ContentfulCardGridProps = {
  filters: Array<ContentfulFilter>;
  numCards?: number;
  useLoadingSkeletons?: boolean;
  cardGridProps?: Omit<CardGridProps, 'cards'>;
  featuredBannerCard?: CardGridCardProps | null;
  featuredBannerCardIndex?: number;
  noResultsPageTitle?: string;
  enableContainerBreakpoints?: boolean;
};

export const ContentfulCardGrid: React.FC<ContentfulCardGridProps> = ({
  filters,
  numCards = 0,
  useLoadingSkeletons = false,
  cardGridProps = {},
  featuredBannerCard = null,
  featuredBannerCardIndex = 5,
  noResultsPageTitle,
  enableContainerBreakpoints = false,
}) => {
  const { cards: cardsProp = [], isLoading } = useCards({ filters, numCards, useLoadingSkeletons });
  const cards = [...cardsProp];

  if (!isLoading && cards.length === 0) {
    return <NoResultsPlaceholder {...getNoCardsPlaceholderProps(noResultsPageTitle)} />;
  }

  if (featuredBannerCard) {
    cards.splice(featuredBannerCardIndex, 0, featuredBannerCard);
  }

  return (
    <CardGrid
      cards={cards.map(card => ({
        ...card,
        width: cardGridProps.isCarousel ? '345px' : undefined,
      }))}
      {...cardGridProps}
      enableContainerBreakpoints={enableContainerBreakpoints}
    />
  );
};
